import { SVGPropsIcon } from 'src/types';

export const DeactivateFullScreen = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="max-w-[35px] md:max-w-[45px]">
      <path
        d="M16.4998 0.0899658L17.9098 1.49997L13.4098 5.99997H16.9998V7.99997H9.99984V0.999966H11.9998V4.58997L16.4998 0.0899658ZM17.9098 16.5L16.4998 17.91L11.9998 13.41V17H9.99984V9.99997H16.9998V12H13.4098L17.9098 16.5ZM1.49984 0.0899658L5.99984 4.58997V0.999966H7.99984V7.99997H0.999844V5.99997H4.58984L0.0898438 1.49997L1.49984 0.0899658ZM0.0898438 16.5L4.58984 12H0.999844V9.99997H7.99984V17H5.99984V13.41L1.49984 17.91L0.0898438 16.5Z"
        fill="white"
      />
    </svg>
  );
};

export const ActivateFullScreen = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="max-w-[35px] md:max-w-[45px]">
      <path
        d="M6.5 10.09L7.91 11.5L3.41 16H7V18H0V11H2V14.59L6.5 10.09ZM7.91 6.5L6.5 7.91L2 3.41V7H0V0H7V2H3.41L7.91 6.5ZM11.5 10.09L16 14.59V11H18V18H11V16H14.59L10.09 11.5L11.5 10.09ZM10.09 6.5L14.59 2H11V0H18V7H16V3.41L11.5 7.91L10.09 6.5Z"
        fill="white"
      />
    </svg>
  );
};

export const ActivateFullScreenIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.104 22.9264H21.354C22.3608 22.9264 23.1769 22.1103 23.1769 21.1035C23.1769 19.2046 23.1769 15.3743 23.1769 15.3743C23.1769 14.9431 22.8269 14.5931 22.3957 14.5931C21.9644 14.5931 21.6144 14.9431 21.6144 15.3743V21.1035C21.6144 21.2473 21.4978 21.3639 21.354 21.3639H15.104C14.6728 21.3639 14.3228 21.7139 14.3228 22.1452C14.3228 22.5764 14.6728 22.9264 15.104 22.9264ZM9.89567 21.3639H3.64567C3.50192 21.3639 3.38525 21.2473 3.38525 21.1035C3.38525 19.2046 3.38525 15.3743 3.38525 15.3743C3.38525 14.9431 3.03525 14.5931 2.604 14.5931C2.17275 14.5931 1.82275 14.9431 1.82275 15.3743V21.1035C1.82275 22.1103 2.6389 22.9264 3.64567 22.9264H9.89567C10.3269 22.9264 10.6769 22.5764 10.6769 22.1452C10.6769 21.7139 10.3269 21.3639 9.89567 21.3639ZM9.89567 1.57227H3.64567C2.6389 1.57227 1.82275 2.38841 1.82275 3.39518V9.12435C1.82275 9.5556 2.17275 9.9056 2.604 9.9056C3.03525 9.9056 3.38525 9.5556 3.38525 9.12435C3.38525 9.12435 3.38525 5.29414 3.38525 3.39518C3.38525 3.25143 3.50192 3.13477 3.64567 3.13477H9.89567C10.3269 3.13477 10.6769 2.78477 10.6769 2.35352C10.6769 1.92227 10.3269 1.57227 9.89567 1.57227ZM15.104 3.13477H21.354C21.4978 3.13477 21.6144 3.25143 21.6144 3.39518V9.12435C21.6144 9.5556 21.9644 9.9056 22.3957 9.9056C22.8269 9.9056 23.1769 9.5556 23.1769 9.12435C23.1769 9.12435 23.1769 5.29414 23.1769 3.39518C23.1769 2.38841 22.3608 1.57227 21.354 1.57227H15.104C14.6728 1.57227 14.3228 1.92227 14.3228 2.35352C14.3228 2.78477 14.6728 3.13477 15.104 3.13477Z"
        fill="white"
      />
    </svg>
  );
};
export const DeactivateFullScreenIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15725_205375)">
        <path
          d="M13.4898 29.7439C13.0586 29.7439 12.7086 29.3946 12.7086 28.9626V22.0728H5.78125C5.35 22.0728 5 21.7235 5 21.2915C5 20.8595 5.35 20.5103 5.78125 20.5103H13.4898C13.9211 20.5103 14.2711 20.8595 14.2711 21.2915V28.9626C14.2711 29.3946 13.9211 29.7439 13.4898 29.7439ZM21.5102 29.7243C21.0789 29.7243 20.7289 29.3751 20.7289 28.9431V21.2337C20.7289 20.8017 21.0789 20.4524 21.5102 20.4524H29.1812C29.6125 20.4524 29.9625 20.8017 29.9625 21.2337C29.9625 21.6657 29.6125 22.0149 29.1812 22.0149H22.2914V28.9431C22.2914 29.3751 21.9414 29.7243 21.5102 29.7243ZM13.4898 14.5478H5.81875C5.3875 14.5478 5.0375 14.1985 5.0375 13.7665C5.0375 13.3345 5.3875 12.9853 5.81875 12.9853H12.7086V6.05713C12.7086 5.6251 13.0586 5.27588 13.4898 5.27588C13.9211 5.27588 14.2711 5.6251 14.2711 6.05713V13.7665C14.2711 14.1978 13.9211 14.5478 13.4898 14.5478ZM29.2188 14.4899H21.5102C21.0789 14.4899 20.7289 14.1407 20.7289 13.7087V6.0376C20.7289 5.60557 21.0789 5.25635 21.5102 5.25635C21.9414 5.25635 22.2914 5.60557 22.2914 6.0376V12.9274H29.2188C29.65 12.9274 30 13.2767 30 13.7087C30 14.1407 29.65 14.4899 29.2188 14.4899Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_15725_205375">
          <rect width="25" height="25" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
